import React, { Component } from 'react'
import { connect } from 'react-redux'

class Titulo extends Component {
  render () {
    const { title } = this.props
    console.log('Titulo:', title)
    return (
      <div>{title}</div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    title: state.utils.title
  }
}

const withRedux = connect(mapStateToProps)
export default withRedux(Titulo)
